import React from 'react';
import PropTypes from 'prop-types';
import css from './StudentSearch.scss'

export default class StudentSearch extends React.Component {

  componentDidMount() {
    this.props.getStudentSearch();
  }

  get searchClass() {
    return this.props.isTopbar ? css["student-search-topbar"] : css["student-search"];
  }

  render() {
    return (
      <div id="sf-student-search" className={this.searchClass}></div>
    );
  }
}

StudentSearch.propTypes = {
  isTopbar: PropTypes.bool,
  getStudentSearch: PropTypes.func.isRequired
};
